import type { ComputedFieldDefinitionId } from "@repo/app-types/entities/computedField";
import { AlertDialog, AlertDialogVariant } from "@repo/ui/Modal/alertDialog";
import { CenteredModal } from "@repo/ui/Modal/centeredModal";
import type { FC } from "react";

export interface ComputedFieldDefinitionDeleteDialogProps {
  computedFieldDefinitionId: ComputedFieldDefinitionId | undefined;
  onConfirm: (computedFieldDefinitionId: ComputedFieldDefinitionId) => void;
  onRequestClose: () => void;
}

export const ComputedFieldDefinitionDeleteDialog: FC<
  ComputedFieldDefinitionDeleteDialogProps
> = ({ computedFieldDefinitionId, onConfirm, onRequestClose }) => {
  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      onRequestClose();
    }
  };

  const handleConfirm = () => {
    if (computedFieldDefinitionId) {
      onConfirm(computedFieldDefinitionId);
    }
    onRequestClose();
  };

  return (
    <CenteredModal
      isOpen={computedFieldDefinitionId !== undefined}
      onOpenChange={handleOpenChange}
      isDismissable
    >
      <AlertDialog
        variant={AlertDialogVariant.Warning}
        title="Delete computed field"
        confirmText="Delete computed field"
        onConfirm={handleConfirm}
      >
        <p>
          Are you sure you want to delete this computed field? This action
          can&apos;t be undone.
        </p>
      </AlertDialog>
    </CenteredModal>
  );
};
